import React, { useState } from 'react';
import { CommunityQueryParams } from '../../types/community';
import { SearchIcon, FilterIcon, XIcon } from 'lucide-react';
interface DirectoryFiltersProps {
  onFilterChange: (filters: Partial<CommunityQueryParams>) => void;
  currentFilters: CommunityQueryParams;
  memberType: 'brand' | 'organizer';
}
export function DirectoryFilters({
  onFilterChange,
  currentFilters,
  memberType
}: DirectoryFiltersProps) {
  const [searchTerm, setSearchTerm] = useState(currentFilters.search || '');
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onFilterChange({
      search: searchTerm
    });
  };
  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onFilterChange({
      category: e.target.value || undefined
    });
  };
  const handleLocationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onFilterChange({
      location: e.target.value || undefined
    });
  };
  const handleEventTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onFilterChange({
      eventType: e.target.value || undefined
    });
  };
  const handleAudienceSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onFilterChange({
      audienceSize: e.target.value || undefined
    });
  };
  const clearFilters = () => {
    setSearchTerm('');
    onFilterChange({
      search: undefined,
      category: undefined,
      location: undefined,
      eventType: undefined,
      audienceSize: undefined
    });
  };
  const filtersApplied = currentFilters.search || currentFilters.category || currentFilters.location || currentFilters.eventType || currentFilters.audienceSize;
  const toggleMobileFilters = () => {
    setShowMobileFilters(!showMobileFilters);
  };
  return <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4 sticky top-20" data-id="element-451">
      <div className="flex justify-between items-center mb-4" data-id="element-452">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-453">Filters</h3>
        <button className="md:hidden inline-flex items-center text-gray-500 hover:text-gray-700" onClick={toggleMobileFilters} data-id="element-454">
          {showMobileFilters ? <XIcon className="h-5 w-5" data-id="element-455" /> : <FilterIcon className="h-5 w-5" data-id="element-456" />}
        </button>
      </div>
      <div className={`md:block ${showMobileFilters ? 'block' : 'hidden'}`} data-id="element-457">
        <form onSubmit={handleSearchSubmit} className="mb-4" data-id="element-458">
          <div className="relative" data-id="element-459">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-460">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-461" />
            </div>
            <input type="text" placeholder="Search..." className="pl-10 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-462" />
          </div>
        </form>
        <div className="space-y-4" data-id="element-463">
          <div data-id="element-464">
            <label htmlFor="category" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-465">
              {memberType === 'brand' ? 'Industry' : 'Category'}
            </label>
            <select id="category" className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm" value={currentFilters.category || ''} onChange={handleCategoryChange} data-id="element-466">
              <option value="" data-id="element-467">All Categories</option>
              {memberType === 'brand' ? <>
                  <option value="food_beverage" data-id="element-468">Food & Beverage</option>
                  <option value="beauty_cosmetics" data-id="element-469">Beauty & Cosmetics</option>
                  <option value="health_wellness" data-id="element-470">Health & Wellness</option>
                  <option value="tech" data-id="element-471">Technology</option>
                  <option value="fashion" data-id="element-472">Fashion & Apparel</option>
                  <option value="home_goods" data-id="element-473">Home Goods</option>
                  <option value="sports_fitness" data-id="element-474">Sports & Fitness</option>
                  <option value="entertainment" data-id="element-475">Entertainment</option>
                </> : <>
                  <option value="festival" data-id="element-476">Festival</option>
                  <option value="conference" data-id="element-477">Conference</option>
                  <option value="expo" data-id="element-478">Expo</option>
                  <option value="workshop" data-id="element-479">Workshop</option>
                  <option value="sports" data-id="element-480">Sports Event</option>
                  <option value="community" data-id="element-481">Community Event</option>
                  <option value="networking" data-id="element-482">Networking Event</option>
                  <option value="concert" data-id="element-483">Concert</option>
                </>}
            </select>
          </div>
          <div data-id="element-484">
            <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-485">
              Location
            </label>
            <select id="location" className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm" value={currentFilters.location || ''} onChange={handleLocationChange} data-id="element-486">
              <option value="" data-id="element-487">All Locations</option>
              <option value="stockholm" data-id="element-488">Stockholm</option>
              <option value="gothenburg" data-id="element-489">Gothenburg</option>
              <option value="malmo" data-id="element-490">Malmö</option>
              <option value="uppsala" data-id="element-491">Uppsala</option>
              <option value="other" data-id="element-492">Other</option>
            </select>
          </div>
          {memberType === 'organizer' && <div data-id="element-493">
              <label htmlFor="eventType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-494">
                Event Type
              </label>
              <select id="eventType" className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm" value={currentFilters.eventType || ''} onChange={handleEventTypeChange} data-id="element-495">
                <option value="" data-id="element-496">All Event Types</option>
                <option value="festival" data-id="element-497">Festival</option>
                <option value="conference" data-id="element-498">Conference</option>
                <option value="expo" data-id="element-499">Expo</option>
                <option value="workshop" data-id="element-500">Workshop</option>
                <option value="sports" data-id="element-501">Sports Event</option>
                <option value="community" data-id="element-502">Community Event</option>
                <option value="networking" data-id="element-503">Networking Event</option>
                <option value="concert" data-id="element-504">Concert</option>
              </select>
            </div>}
          <div data-id="element-505">
            <label htmlFor="audienceSize" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-506">
              Audience Size
            </label>
            <select id="audienceSize" className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm" value={currentFilters.audienceSize || ''} onChange={handleAudienceSizeChange} data-id="element-507">
              <option value="" data-id="element-508">All Sizes</option>
              <option value="under_100" data-id="element-509">Under 100</option>
              <option value="100_500" data-id="element-510">100 - 500</option>
              <option value="500_1000" data-id="element-511">500 - 1,000</option>
              <option value="1000_5000" data-id="element-512">1,000 - 5,000</option>
              <option value="5000_plus" data-id="element-513">5,000+</option>
            </select>
          </div>
          {filtersApplied && <button type="button" onClick={clearFilters} className="text-sm text-indigo-600 hover:text-indigo-800 mt-2" data-id="element-514">
              Clear all filters
            </button>}
        </div>
      </div>
    </div>;
}